import { Fragment, useState, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Login } from "../../components/backgrounds/Login";
import { Otp, digitosFirma } from "../../components/legal/Otp";
import { HttpRequest } from '../../services/httpRequest';
import { SuccessAlert } from '../../components/alerts/successAlert';
import { ErrorAlert } from '../../components/alerts/errorAlert';
import { ProgressLinear } from '../../components/progress/progressLinear';
import { AuthContext } from '../../context/Auth/AuthContext';
import { Primary } from '../../components/buttons/Primary'

export function VerificationEmailPage() {

  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const emailUser = state?.email || "";
  const doc = state?.doc || "";
  const correoProtect = emailUser.substring(5, 0) + "*****" + emailUser.split('@')[1]
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);
  const [viewProgress, setViewProgress] = useState(false);
  const [isSendToken, setIsSendToken] = useState(state?.isSendToken);

  const handleClearStateAlert = () => {

    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);

  }

  const handleSendtokenEmail = async () => {

    handleClearStateAlert();
    setIsSendToken(false);

    try {

      let payload = Object.assign({}, { doc: doc });

      const responseService = await HttpRequest.loginRequestEmail(payload);

      console.log('imprimiendo responseService', responseService);

      if (responseService.error) {

        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert('error', 'Ups! El usuario no existe con el documento ingresado.', true);
          return;
        }

        else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert('error', `Ups! ${responseService.message.message}`, true);
          return;
        }

        else if (responseService.message.code === "INVALIDCREDENTIALS") {
          handleOpenAlert('error', `Ups! ${responseService.message.message}`, true);
          return;
        }

        handleOpenAlert('error', 'Ups! Error interno, intenta nuevamente', true);
        return;
      }
      
      handleOpenAlert('success', 'Te enviamos un token a tu email registrado!', true);

    } catch (error) {
      console.log(error);
      return navigate("/negado")
    }
  }

  if (isSendToken) {
    handleSendtokenEmail().then().catch(e => console.log(e));
  }

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === 'success') {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
    }
    if (type === 'error') {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
    }
  }

  const handleProgress = (isView) => {
    setViewProgress(isView)
  }

  const handleSubmit = async (event) => {
    try {

      handleClearStateAlert();

      event.preventDefault();

      handleProgress(true);

      let payload = Object.assign({}, { doc: doc, token: token });

      const responseService = await HttpRequest.validateToken(payload);

      console.log('imprimiendo responseService', responseService);

      if (responseService.error) {

        if (responseService.code === "ERR_BAD_REQUEST") {
          handleOpenAlert('error', 'Ups! Token Inválido', true);
          return;
        }

        handleOpenAlert('error', 'Ups! Error interno, intente más tarde', true);
        return;

      }

      setTimeout(() => {
        handleProgress(false);
        localStorage.setItem('doc', responseService.message.doc);
        localStorage.setItem('is_signin', true);
        localStorage.setItem("token", responseService.message.otp);
        //localStorage.setItem("token_jwt", responseService.message.tokenJwt);
        return navigate("/micredito", { replace: true, state: {} });
      }, 3000);

    } catch (error) {
      console.log(error);
      handleProgress(false);
      return navigate("/negado")
    }
  }

  return (
    <Fragment>
      {
        viewalert ?
          <>
            <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
            <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
          </>
          : <></>
      }
      <Login
        title="Verificación de seguridad."
        description={`Digita el código de ${digitosFirma} dígitos que hemos enviado a tu correo ${correoProtect}.`}
        form={

          <form action="#" method="POST" className="space-y-6 h-96" onSubmit={handleSubmit}>


            <div className="block">
              <Otp name="tokensms" id="tokensms" />
            </div>
            <div>
              {
                viewProgress ?
                  <Fragment>
                    <ProgressLinear></ProgressLinear>
                    <p>Estamos verificando el código, por favor espera...</p>
                  </Fragment>

                  :
                  
                  <Primary onSubmit={handleSubmit} text={'Verificar código'} />
              }
            </div>
            <div className="items-center pb-10">
              <div className="block items-center">
                <a href="#" className="block text-purple underline">
                  Reenviar código
                </a>
                <span className="block lg:hidden justify-center pt-4">
                  ¿No tienes acceso a tu correo?{" "}
                  <a
                    href="/autenticarse"
                    className="text-purple block md:flex underline"
                  >
                    {" "}
                    Intenta con tu celular.{" "}
                  </a>
                </span>
              </div>
            </div>
          </form>
        }
        message={
          <span className="flex justify-center pt-10 mx-auto text-lg">
            ¿No tienes acceso a tu correo?{" "}
            <a href="#" className="text-purple pl-2 underline">
              {" "}
              Intenta con tu celular.{" "}
            </a>
          </span>
        }
      />

    </Fragment>
  );
}
